import { useMemo } from 'react';

/**
 * True when the current page is the LiveKit egress render page (the headless
 * browser the recorder loads), NOT a live participant's meeting view.
 *
 * Detection mirrors `RecordSimulatorIndex` exactly: that page lives at the
 * `/record/$meetingId` route and reads its egress token straight off the raw
 * URL (`?token=...`) rather than through TanStack's `useSearch`, because the
 * egress SDK relies on the raw param. We key off the same two signals so a
 * recorder render is always identified the same way the renderer identifies
 * itself.
 *
 * The recorder must show no toasts/notifications at all, so callers that drive
 * meeting toasts guard on this and bail when it's true.
 */
export const useIsRecordingRenderer = (): boolean => {
	return useMemo(() => {
		if (typeof window === 'undefined') return false;
		const isRecordRoute = window.location.pathname.startsWith('/record/');
		const hasEgressToken = new URLSearchParams(window.location.search).has('token');
		return isRecordRoute && hasEgressToken;
	}, []);
};
